import React, { useState } from 'react';
import { ReadinessDashboard } from './ReadinessDashboard';
import { ReadinessHistory } from './ReadinessHistory';
import { SymptomTriage } from './SymptomTriage';
import { ReadinessWizard } from './ReadinessWizard';

const SUB_VIEWS = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'wizard', label: 'Wizard' },
  { id: 'triage', label: 'Triage' },
  { id: 'history', label: 'History' },
];

function ReadinessSubView({ viewId }) {
  if (viewId === 'wizard') return <ReadinessWizard />;
  if (viewId === 'triage') return <SymptomTriage />;
  if (viewId === 'history') return <ReadinessHistory />;
  return <ReadinessDashboard />;
}

export default function OrderGenieReadiness() {
  const [activeView, setActiveView] = useState('dashboard');

  return (
    <div className="order-genie-readiness">
      <ul className="nav nav-pills flex-nowrap overflow-x-auto gap-2 mb-3" role="tablist" aria-label="Readiness views">
        {SUB_VIEWS.map((view) => (
          <li className="nav-item flex-shrink-0" key={view.id}>
            <button
              type="button"
              className={`nav-link ${activeView === view.id ? 'active' : ''}`}
              onClick={() => setActiveView(view.id)}
              role="tab"
              aria-selected={activeView === view.id}
            >
              {view.label}
            </button>
          </li>
        ))}
      </ul>
      <ReadinessSubView viewId={activeView} />
    </div>
  );
}
